/**
 * DreamTwin™ barrel export
 */
export type {
  DreamTwin,
  DreamTwinContextValue,
  DreamTwinIdentity,
  DreamTwinBrand,
  DreamTwinAudience,
  DreamTwinProducts,
  DreamTwinProduct,
  DreamTwinMarketing,
  DreamTwinWebsite,
  DreamTwinPlan,
  DreamTwinOperations,
  DreamTwinAnalytics,
  DreamTwinLearning,
  DreamTwinRecommendation,
} from './types';
export { DREAMTWIN_SYSTEM_PROMPT } from './types';
export { DreamTwinProvider, useDreamTwin } from './context';
